/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { apiClient } from './client.js';

export interface Me {
  readonly id: string;
  readonly fullName: string;
  readonly email: string;
  readonly roles: readonly string[];
}

export const meApi = {
  async get(): Promise<Me> {
    const { data } = await apiClient.get<Me>('/auth/me');
    return data;
  },
};
